import { AuthResponseData } from '../service/auth.service';
import { AuthService } from './../service/auth.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { NgForm } from '@angular/forms';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  isLoading = false;
  error = null;
  testSite = false;
  emailObj: any;
  redirect: any;

  constructor(
    private authService: AuthService,
    private router: Router,
    private cookieService: CookieService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    // are we logged in?
    this.testSite = environment.testSite;
    const user = this.authService.user.getValue();
    this.isLoading = true;

    this.route.queryParams.subscribe((params) => {
      var r = new RegExp('^(?:[a-z+]+:)?//', 'i');
      if (!r.test(params['r'])) {
        this.redirect = params['r'];
      }
    });
    // try this..
    this.authService.user.subscribe((user) => {
      if (user) {
        if (this.authService.redirect) {
          this.router.navigateByUrl(this.authService.redirect);
        } else {
          this.router.navigate(['/dashboard']);
        }
      } else {
        // small hack to hide the login page when still searching for user...
        const appAuthed = this.cookieService.get('appAuthed');
        if (appAuthed) {
          setTimeout(() => {
            this.isLoading = false;
          }, 1000);
        } else {
          this.isLoading = false;
        }
      }
    });
  }
  onSubmit(form: NgForm) {
    if (!form.valid) {
      return;
    }
    let email = form.value.email;
    let password = form.value.password;
    let rememberMe = form.value.rememberMe;
    let authObs: Observable<AuthResponseData>;

    this.isLoading = true;

    authObs = this.authService.login(email, password, rememberMe);

    authObs.subscribe(
      (resData) => {
        form.reset();
        this.isLoading = false;
        // do they need to evaluate?
        if (this.redirect) {
          this.router.navigateByUrl(this.redirect);
        } else {
          this.router.navigate(['/dashboard']);
        }
      },
      (errorMessage) => {
        this.error = errorMessage;
        this.isLoading = false;
      },
    );
  }
}
